import { LogoDefinition } from '../types';

export const brandIcon: LogoDefinition = {
  id: 'brandIcon',
  width: 176,
  height: 176,
  svgContent: [
    {
      type: 'path',
      fill: '#ffffff',
      data: 'M176.025 -0.0380859H0.0253906V175.962H176.025V-0.0380859Z',
    },
    {
      type: 'path',
      fill: '#ffb800',
      data: 'M87.953 71.2336C92.7746 71.2336 97.488 69.8038 101.497 67.125C105.506 64.4463 108.631 60.6388 110.476 56.1842C112.321 51.7296 112.804 46.8278 111.863 42.0988C110.923 37.3698 108.601 33.0259 105.191 29.6165C101.782 26.207 97.438 23.8852 92.709 22.9445C87.98 22.0039 83.0783 22.4866 78.6236 24.3318C74.169 26.177 70.3615 29.3017 67.6828 33.3107C65.004 37.3198 63.5742 42.0332 63.5742 46.8548C63.5742 53.3205 66.1427 59.5213 70.7146 64.0932C75.2865 68.6651 81.4873 71.2336 87.953 71.2336Z',
    },
    {
      type: 'path',
      fill: '#0445a5',
      data: 'M128.709 76.792H104.254L88.0294 98.4981L71.727 76.792H47.1953L75.7644 114.73L47.1953 152.819H71.727L88.0294 131.031L104.254 152.819H128.709L100.215 114.73L128.709 76.792Z',
    },
  ],
};
